/**
 * @desc 财务画像-基础信息-股权信息
 */
import React, { PureComponent } from 'react';
import GroupBox from '../../../common/groupBox/GroupBox';
import AntdTable from '../../common/AntdTable';
import { Table } from 'antd';
import { addDataIndex, addUniqueField } from '../../../../utils/util';
import {
    subCompany, topTenShareholder, actualController,
    reduceShareholder, companyDividend
} from '../common/columns'; // pledgeShareholder
import { topTenShareholderApi, ActualControllerApi, companyDividendApi,
    subsidiaryForm, reduceShareholderApi
} from '../../../../services/financialPicture/baseInfo';
import { commonRequest } from '../../common/commons';

export default class EquityInformation extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tableData: [],
            topTenData: [],
            tenLoading: false,
            actualData: [],
            dividendData: []
        };
    }

    componentDidMount() {
        this.topTenShareholderPort();
        this.ActualControllerPort();
        this.companyDividendPort();
    }

    // 前十大股东持股信息
    topTenShareholderPort = () => {
        this.setState({
            tenLoading: true
        });
        topTenShareholderApi(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                tenLoading: false,
                topTenData: addDataIndex(data || [], 1, 10)
            });
        }).finally(() => {
            this.setState({
                tenLoading: false
            });
        });
    };

    // 实际控制人及变更情况
    ActualControllerPort = () => {
        ActualControllerApi(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                actualData: addUniqueField(data || [])
            });
        });
    };

    // 公司近年分红情况
    companyDividendPort = () => {
        companyDividendApi(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                dividendData: data || []
            });
        });
    };

    render() {
        const { topTenData, tenLoading, actualData, dividendData } = this.state;
        // tableData  股东质押情况
        return (
            <div>
                <AntdTable
                    idName={'subsidiaries-constitute'}
                    title={'子公司的构成'}
                    requestApi={subsidiaryForm}
                    columns={subCompany}
                    list={true}
                />
                
                <GroupBox title="前十大股东持股信息" id="top-ten-Shareholder" className="margin-top-40">
                    <Table
                        pagination={false}
                        bordered
                        loading={tenLoading}
                        rowKey="index"
                        dataSource={topTenData}
                        columns={topTenShareholder}
                    />
                </GroupBox>
                <GroupBox title="实际控制人及变更情况" id="actual-controller" className="margin-top-40">
                    <Table
                        pagination={false}
                        bordered
                        rowKey="id"
                        dataSource={actualData}
                        columns={actualController}
                    />
                </GroupBox>
                <AntdTable
                    idName={'reduce-shareholder'}
                    title={'股东减持情况'}
                    requestApi={reduceShareholderApi}
                    columns={reduceShareholder}
                    list={true}
                />
                {/* <GroupBox title="股东质押情况" id="pledge-shareholder" className="margin-top-40">
                    <Table
                        pagination={false}
                        bordered
                        rowKey={record => Object.values(record).join('_')}
                        dataSource={tableData}
                        columns={pledgeShareholder}
                    />
                </GroupBox> */}
                <GroupBox title="公司近年分红情况" id="company-dividend" className="margin-top-40">
                    <Table
                        pagination={false}
                        bordered
                        rowKey="endDate"
                        dataSource={dividendData}
                        columns={companyDividend}
                    />
                </GroupBox>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/equityInformation/EquityInformation.jsx